import axios from 'axios'

axios.defaults.baseURL = 'https://smartidregistration.onoi.kg/'

export default function interceptors() {
  axios.interceptors.request.use(
    function(config) {
      return config
    },
    function(error) {
      return Promise.reject(error)
    }
  )

  axios.interceptors.response.use(
    function(response) {
      return response
    },
    function(error) {
      if (error.response.status === 401) {
        alert('Вы не авторизованы')
        sessionStorage.clear()
        this.$router.push({ path: '/' })
      }
      return Promise.reject(error)
    }
  )
}
